// Static configuration for the Live Sessions page (levels legend, country/timezone
// selector and weekday columns). The level descriptions/CEFR ranges/colors are fixed
// marketing copy, so they live here rather than in the database.

export type LevelKey = 'beginner' | 'intermediate' | 'advanced' | 'general';

export interface LevelConfig {
    labelKey: string;
    descKey: string;
    cefr: string;
    color: string;
}

export const LEVELS: Record<LevelKey, LevelConfig> = {
    beginner: {
        labelKey: 'liveSessions.levels.beginner.label',
        descKey: 'liveSessions.levels.beginner.description',
        cefr: 'A1 – A2',
        color: '#2f7d3b',
    },
    intermediate: {
        labelKey: 'liveSessions.levels.intermediate.label',
        descKey: 'liveSessions.levels.intermediate.description',
        cefr: 'B1 – B2',
        color: '#2a8a8a',
    },
    advanced: {
        labelKey: 'liveSessions.levels.advanced.label',
        descKey: 'liveSessions.levels.advanced.description',
        cefr: 'B2 – C1',
        color: '#6b4a9c',
    },
    general: {
        labelKey: 'liveSessions.levels.general.label',
        descKey: 'liveSessions.levels.general.description',
        cefr: 'liveSessions.levels.general.cefr',
        color: '#7a7d2a',
    },
};

export const LEVEL_ORDER: LevelKey[] = ['beginner', 'intermediate', 'advanced', 'general'];

export type TimeField = 'time_es' | 'time_ar' | 'time_co' | 'time_mx' | 'time_ec';

export interface CountryConfig {
    code: string;
    label: string;
    flag: string;
    timeField: TimeField;
}

// México first — it is the default country/timezone in the source design.
export const COUNTRIES: CountryConfig[] = [
    { code: 'mx', label: 'México', flag: '🇲🇽', timeField: 'time_mx' },
    { code: 'es', label: 'España', flag: '🇪🇸', timeField: 'time_es' },
    { code: 'ar', label: 'Argentina', flag: '🇦🇷', timeField: 'time_ar' },
    { code: 'co', label: 'Colombia', flag: '🇨🇴', timeField: 'time_co' },
    { code: 'ec', label: 'Ecuador', flag: '🇪🇨', timeField: 'time_ec' },
];

export const DEFAULT_COUNTRY_CODE = 'mx';

export interface DayConfig {
    key: string;
    order: number;
    labelKey: string;
}

export const DAYS: DayConfig[] = [
    { key: 'lunes', order: 0, labelKey: 'liveSessions.days.lunes' },
    { key: 'martes', order: 1, labelKey: 'liveSessions.days.martes' },
    { key: 'miercoles', order: 2, labelKey: 'liveSessions.days.miercoles' },
    { key: 'jueves', order: 3, labelKey: 'liveSessions.days.jueves' },
    { key: 'viernes', order: 4, labelKey: 'liveSessions.days.viernes' },
];
